import React, { useRef } from "react";
import styled from 'styled-components'
import Zoom from 'react-reveal/Zoom';

export const OverlayContainer = styled('div')`
    position: fixed;
    bottom: 0;
    left: 0;
    height: 100%;
    background-color: white;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    @media(min-width: 100px) {
      font-weight: 100;
      font-family: 'Roboto';
      font-size: 0.7rem;
    }

    @media(min-width: 300px) {
      font-weight: 250;
      font-family: 'Roboto';
      font-size: 1.2rem;
    }

    @media(min-width: 768px) {
      font-weight: 400;
      font-family: 'Roboto';
      font-size: 1.5rem;
    }

    @media(min-width: 1024px) {
      font-weight: 500;
      font-family: 'Roboto';
      font-size: 1.7rem;
    }
`

export const Life = styled('div')`
  //position: relative;
  margin-left: auto;
  margin-right: auto;
  padding-right: 2vw;
  padding-left: 2vw;
  //padding-top: 10%;
  margin-top: auto;
  margin-bottom: auto;
  text-align: left;
  //top: 0px;
  color: black;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const ButtonDiv = styled('div')`
  text-align: center;
  color: black;
  margin-top: 4vh;
  padding: 2vh;
`

const Overlay = ({ fullScreen = false, currentQuestion = {}, sendReply }) => {

  return (
      <div>
        {fullScreen && <OverlayContainer
          className="overlay-container1"
        >
          <div>
          <Zoom duration={2000} top>
          <Life >{currentQuestion.text}</Life>
          <Life style={{flexDirection: 'row'}}>
            <ButtonDiv onClick={() => sendReply(true)}>
              [YES]
            </ButtonDiv>
            <ButtonDiv  onClick={() => sendReply(false)}>
              [NO]
            </ButtonDiv>
          </Life>
          </Zoom>
          </div>
        </OverlayContainer>
        }
      </div>
      )
};

export default Overlay;
